import script from "./ProspectManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ProspectManagement.vue?vue&type=script&setup=true&lang=js"

import "./ProspectManagement.vue?vue&type=style&index=0&id=f63aae26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f63aae26"]])

export default __exports__